import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { applicationStore, LoginStatus } from "@website/store/store";
import { useWebengage } from "@website/tracking/tracking.webengage.hook";
import { getChannel } from "@website/utils/channel/get-channel";
import { setChannel } from "@website/utils/channel/set-channel";
import toString from "lodash-es/toString";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { convertToken, useAuthSessionRefresh, useLoginStatus } from "./utils";

setChannel();

export const useAuth = () => {
  const searchParameters = useSearchParams();
  const { loginStatus } = useLoginStatus();
  const pathName = usePathname();
  const currentChannel = getChannel();
  const isPwa = toString(searchParameters?.get("ispwa"));
  const appVersion = toString(searchParameters?.get("app_version"));
  const queryToken = toString(searchParameters?.get("token"));
  const searchParametersKey = searchParameters?.toString() || "";
  useConvertToken();
  useAuthSessionRefresh({
    routeChangeKey: `${pathName || ""}?${searchParametersKey}`,
    queryToken
  });
  useEffect(() => {
    if (isPwa) {
      applicationStore.applicationData.isPwa.set(isPwa === "true");
    }
    if (appVersion) {
      applicationStore.applicationData.appVersion.set(appVersion);
    }
  }, [isPwa, appVersion]);

  useEffect(() => {
    if (
      currentChannel === "b2b" &&
      loginStatus === LoginStatus.LoggedOut &&
      pathName !== "/b2b-login"
    ) {
      window.location.href = `/b2b-login`;
    }
  }, [loginStatus, pathName, currentChannel]);
};

export const useConvertToken = () => {
  const searchParameters = useSearchParams();
  const { login } = useWebengage();
  const queryToken = toString(searchParameters.get("token"));
  useFetcherV2({
    queryKey: ["auth-cookie", "convert-token", getChannel(), queryToken],
    enabled: true,
    queryFn: async () => {
      await convertToken(queryToken, login);
    }
  });
};
